import Field from '../../Field';
import { type FieldContentsData } from 'javascripts/shared-types';

export class DependenciesCount extends Field {
  static attributesForModel() {
    return ['dependenciesCount'];
  }

  get title() {
    return 'Dependencies';
  }

  exampleContents(): FieldContentsData {
    return { text: 6, icon: { name: 'aha-icon aha-icon-dependencies' } };
  }

  contentsForRecord(record): FieldContentsData {
    if (typeof record.dependenciesCount === 'number') {
      return {
        text: record.dependenciesCount,
        icon: { name: 'aha-icon aha-icon-dependencies' },
      };
    }

    return {};
  }
}
